import React from 'react';

import PropTypes from 'prop-types';

import Tooltip from '@tds/core-tooltip';
import { ToolTipWrapper } from '../css';
import RichText from '../../../richText';

const FieldGuide = ({ tooltip, isRichText }) => {
  return (
    <ToolTipWrapper>
      <Tooltip copy="en">
        {isRichText ? <RichText data={tooltip} /> : tooltip}
      </Tooltip>
    </ToolTipWrapper>
  );
};

FieldGuide.propTypes = {
  tooltip: PropTypes.string.isRequired,
  isRichText: PropTypes.bool
};

FieldGuide.defaultProps = {
  isRichText: false
};

export default FieldGuide;
